<template>
    <div class="account">
        <div class="container">
            <div class="account__wrapper">
                <AccountSideMenu></AccountSideMenu>

                <div class="account__contain privacy">
                    <h5 class="account__section-title">Prywatność:</h5>
                    
                    <div class="privacy__items">
                        <a href="https://polityka-prywatnosci.tvp.pl" class="privacy__item">
                            <IconPrivacyPolicy class="privacy__icon"></IconPrivacyPolicy>
                            <span class="privacy__text">Polityka prywatności</span>
                        </a>

                        <a href="https://vod.tvp.pl/page/regulamin,1653650" class="privacy__item">
                            <IconRules class="privacy__icon"></IconRules>
                            <span class="privacy__text">Regulamin aplikacji</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccountSideMenu from "./AccountSideMenu.vue";
import IconPrivacyPolicy from "../elements/icons/IconPrivacyPolicy.vue";
import IconRules from "../elements/icons/IconRules.vue";

export default {
    name: "AccountPrivacy",
    components: {
        AccountSideMenu,
        IconPrivacyPolicy,
        IconRules
    },
    data() {
        return {
        };
    },
    computed: {
        path() {
            return this.$route.path;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    mounted() {
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        ); 
    }
};
</script>